<!--
  @description 工单统计
  @author libaiqi
  @date 2018/12/25
-->
<template>
  <div class="orderStatistics__content">
    <el-form ref="form" :model="form" :inline="true" input-width="auto">
      <el-form-item :label="$t('orderStatistics.year')">
        <el-input type="number" v-model="form.year" :min="1000"></el-input>
      </el-form-item>
      <el-form-item :label="$t('orderStatistics.month')">
        <el-input type="number" v-model="form.month" :min="1"></el-input>
      </el-form-item>
      <el-form-item :label="$t('orderStatistics.orderType')">
        <g-select :list="select_type" v-model="form.orderType" :default-all="true"></g-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getOrderStatistics" v-g-rac="gRac('orderStatistics@search')">{{ $t('common.search') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="mt-base orderStatistics__chart">
      <chart-base 
        ref="orderStatistics" 
        chart-id="orderStatistics" 
        :chart-data="chartData" 
        :chart-style="chartOpt">
      </chart-base>
    </div>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import orderStatisticsBiz from '@/logic/workFlow/orderStatisticsBiz'
  import resApplicationBiz from '@/logic/workFlow/resApplicationBiz'
  import chartBase from '@/components/chart/chart-base.vue'

  export default {
    mixins: [rac, dic],
    components: {
      chartBase
    },
    data () {
      return {
        form: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          orderType: ''
        },
        select_type: {},
        chartOpt: null,
        chartData: {},
        legendList: []
      }
    },
    methods: {
      setChartOpt () {
        let legendData = []
        this.legendList.map(item => {
          legendData.push(this.select_type[item])
        })
        this.chartOpt = {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          legend: {
            type: 'scroll',
            width: '70%',
            top: '4%',
            data: legendData
          }
        }
      },
      drawChart (data) {
        let labelMap = {}
        this.legendList.map(item => {
          labelMap[item] = this.select_type[item]
        })
        this.chartData = {
          rows: data,
          columns: ['time', ...this.legendList],
          labelMap: labelMap,
          seriesStyle: {
            lineStyle: {
              normal: {
                width: 1.6
              }
            },
            symbol: 'emptyCircle'
          }
        }
      },
      translateData2Chart (data) {
        let arr = []
        this.legendList = []
        for (let i in data) {
          Object.keys(data[i]).map((item, index) => {
            let obj = {}
            if (item !== 'month' && item !== 'year' && item !== 'week') {
              if (this.legendList.indexOf(item) === -1) {
                this.legendList.push(item)
              }
              obj[item] = data[i][item]
            }
            arr[i] = { ...obj, ...arr[i] }
          })
          arr[i].time = data[i].week === 0 ? data[i].year + this.$t('orderStatistics.year') + data[i].month + this.$t('orderStatistics.month') : data[i].month + this.$t('orderStatistics.month') + this.$t('orderStatistics.number') + data[i].week + this.$t('orderStatistics.week')
        }
        return arr
      },
      getOrderType () {
        resApplicationBiz.getAll().then(data => {
          let dicObj = {}
          for (let i of data) {
            dicObj[i.processDefinitionId] = i.name
          }
          this.select_type = { ...dicObj }
        })
      },
      getOrderStatistics () {
        if (this.form.year % 1 !== 0) {
          this.$message({
            message: this.$t('orderStatistics.yearAlert'),
            type: 'warning'
          })
          return
        }
        if (this.form.month !== '' && (this.form.month % 1 !== 0 || !(this.form.month < 13 && this.form.month > 0))) {
          this.$message({
            message: this.$t('orderStatistics.monthAlert'),
            type: 'warning'
          })
          return
        }
        this.form.year = this.form.year === '' ? new Date().getFullYear() : this.form.year
        const data = {}
        data.year = Number(this.form.year)
        data.orderType = this.form.orderType
        if (this.form.month !== '') {
          data.month = Number(this.form.month)
        }
        orderStatisticsBiz.getOrderStatistics(data).then((res) => {
          let arr = this.translateData2Chart(res)
          this.setChartOpt()
          this.$nextTick(() => {
            this.drawChart(arr)
          })
        })
      }
    },
    mounted () {
      this.getOrderType()
      setTimeout(() => {
        this.getOrderStatistics()
      })
    }
  }
</script>
<style scoped>
  .orderStatistics__chart {
    height: 500px;
  }
</style>